import RelationsEditable from 'components/RelationsEditable';
import RelationsTable from 'components/RelationsTable';
import useEntities from 'hooks/useEntities';
import useLoginStore from 'store/loginStore';

const PlayerPositions = ({ data, sourceEntityId, sourceEntityData, onChange }) => {
    const entities = useEntities();
    const isAdmin = useLoginStore(s => s.isAdmin)();

    return (
        isAdmin || sourceEntityData?.status == 'DRAFT' || sourceEntityData?.status == 'INVITED'
            ?
                <RelationsEditable
                    data={data}
                    sourceEntity={entities.Player} 
                    targetEntity={entities.ListPosition}
                    emptyMessage="This player does not have any positions"
                    sourceEntityId={sourceEntityId}
                    addButtonText="Add Positions"
                    onChange={onChange}
                />
            :
                <RelationsTable
                    data={data}
                    sourceEntity={entities.Player} 
                    targetEntity={entities.ListPosition}
                    emptyMessage="This player does not have any positions"
                    sourceEntityId={sourceEntityId}
                />
    )
}

export default PlayerPositions
